import { useSyncExternalStore } from 'react';

import { authState } from './state';

export const useAuthState = () => {
  const auth = useSyncExternalStore(authState.sub, authState.get);
  const { accessToken, tokenType, userInfo } = auth;
  const isAuthenticated = Boolean(accessToken && tokenType);

  return {
    accessToken,
    tokenType,
    isAuthenticated,
    userInfo,
  };
};
